export const currencyValues = {
    "- None -": "",
    SEK: "SEK",
    EUR: "EUR",
}
